import store from '@/store'
import { get, size } from 'lodash'
import toast from '@/plugins/toast/toast'
import { hasRole } from '@/helpers/user/roles'
import { routeIsPatient } from '@/helpers/routes'

const isSettings = to => to.name === 'settings.profile.me'
const isDashboard = to => to.name === 'dashboard'
const isPatient = user => user.type === 'dweller'
const isTenant = user => user.type === 'tenant'
const isProfessional = user => user.type === 'professional'

const matched = to => size(to.matched) > 0
const userHasRole = (to, user) => hasRole(user, get(to, 'meta.role', 'company'))
const granted = (to, user) => {
  const has = userHasRole(to, user)

  if (!has) {
    toast.error('Você não tem permissão para acessar essa página.')
  }

  return has
}

/**
 * Runs before each route change.
 *
 * @param to
 * @param from
 * @param next
 */
const beforeEach = (to, from, next) => {
  // setup page title (not vue handled).
  document.title = get(to, 'meta.title', 'Condomum - Sistema para condominios')

  // bypass user setup if route does not need auth.
  if (to.meta.auth === false) { return next() }

  // dispatch the user info actions and continue the request after.
  return store.dispatch('setupUser')
    .then((user) => {
      if (routeIsPatient(to) && (!isPatient(user) && !isProfessional(user))) {
        return next({name: 'professional.dashboard.professional.index'})
      }
      if (isSettings(to) && !isPatient(user)) {
        return next({name: 'professional.profile.me'})
      }

      if (isDashboard(to) && !isTenant(user)) {
        const pathTo = isPatient(user) ? 'dweller' : 'professional'

        return next({name: pathTo + '.dashboard.index'})
      }

      if (isDashboard(to)) {
        const pathTo = isTenant(user) ? 'tenant' : 'professional'

        return next({name: pathTo + '.dashboard.index'})
      }

      if (matched(to) && granted(to, user)) {
        return next()
      }

      if (!isPatient(user)) {
        return next({name: 'professional.profile.me'})
      }

      return next({name: 'index'})
    })
    .catch(() => next({name: 'auth.login'}))
}

export default beforeEach



// WEBPACK FOOTER //
// ./src/router/beforeEach.js